import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@tillersystems/stardust';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Iframe from 'react-iframe';

import { Page } from '../../components';
import { CalendyContainer } from './elements';

import * as NavActions from '../../services/NavigationService/actions';
import * as SFActions from '../../services/DataServices/SFDataService/actions';

const { object, func } = PropTypes;

/**
 * Training page
 *
 * This component is in charge of displaying
 * a the training page
 *
 * @return {jsx}
 */

export class Training extends Component {
  state = {
    stageValue: 'Your training',
    stageNumber: 5,
  };

  /**
   * PropTypes validation
   */
  static propTypes = {
    actions: object.isRequired,
    t: func.isRequired,
    opportunity: object.isRequired,
  };

  constructor(props) {
    super(props);
    this.calendly = React.createRef();
  }

  async componentDidMount() {
    const { actions, opportunity } = this.props;
    const { stageValue, stageNumber } = this.state;

    actions.sendBackDataToSalesforce();

    if (opportunity._stageValue !== null) {
      actions.opportunityNeedUpdate(opportunity.getId(), stageValue, stageNumber);
    }
    actions.setCurrentStep(4);
  }

  render() {
    const { t, opportunity } = this.props;
    return (
      <Page>
        <Page.Title>{t('trainingPage.heading')}</Page.Title>
        <Page.Paragraph>{t('trainingPage.content')}</Page.Paragraph>
        <CalendyContainer>
          <Iframe
            url={opportunity._calendlyLinkCsm}
            width="0"
            height="100%"
            id="calendly"
            position="relative"
          />
        </CalendyContainer>
        <Link to="/thanks">
          <Button big primary fluid>
            {t('trainingPage.button')}
          </Button>
        </Link>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  opportunity: state.opportunity,
});

/**
 * Action creators does our component
 * want to receive by props
 */
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...NavActions, ...SFActions }, dispatch),
});

const TrainingConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Training);

export default translate('translations')(TrainingConnect);



// WEBPACK FOOTER //
// ./src/pages/Training/index.js